const Data = [
    {
        id: 1,
        category: "education",
        icon: "icon-graduation",
        year: "2022-Sept - 2024-Sept",
        title: "Diploma in Computer Science",
        desc: "Courses: Java, Android, Data Structures and Algorithms, Operating Systems, Network Security",
    },
];

export default Data